import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Id = iotsUtils.fromList(constants.transaction.collaborator.type.ids);
